import * as React from 'react';
import {IFamilyMember, IFamilyMemberFileIdUpdate} from '@app-types/websocket/family.types';
import {WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {childinfoStyle} from './childinfo.style';
import {default as InfoIcon} from '@material-ui/icons/Info';
import {FamilyMemberType} from '@services/family/family.constants';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import AutosizeTextArea from './AutosizeTextArea';
import {IChildInfo, IChildInfoUpdate} from '@app-types/websocket/sharedinfo.types';
import Button from '@components/common/button/Button';
import ChildInfoVaccinations from './ChildInfoVaccinations';
import Dialog from "@components/common/dialog/dialog.component";
import UpdateFamilyMemberDialog from '@components/extended-family/update-family-member/UpdateFamilyMemberDialog';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof childinfoStyle> {
  userRole: FamilyMemberType;
  userId: number;
  child: IFamilyMember;
  family: IFamilyMember[];
  childInfo?: IChildInfo;
  updateChildInfo: (data: IChildInfoUpdate) => void;
  updateFamilyMember: (data: IFamilyMember) => void;
  updateFamilyMemberFileId: (data:IFamilyMemberFileIdUpdate) => void;
}

interface IState {
  childInfo: IChildInfo;
  passLocation: string;
  showPassDetails: boolean;
  showVaccDetails: boolean;
  changeMade: boolean;
  showEditAvatarDialog:boolean;
}

class ChildInfo extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);


    let childInfo;
    let passLocation = "";
    if (props.childInfo !== undefined) {
      childInfo = props.childInfo;
      if (childInfo.passHistory.length > 0) {
        passLocation = childInfo.passHistory[0].location;
      }
    } else {
      childInfo = {
        accountId: props.child.id,
        socialNo: (props.child.yearBorn ? ("" + props.child.yearBorn) : ""),
        passNo: "",
        passHistory: [],
        clothingSize: "",
        shoeSize: "",
        meds: "",
        allergies: "",
        insurance: "",
        vaccinations: [],
      };
    }

    this.state = {childInfo, passLocation, showPassDetails: false, showVaccDetails: false, changeMade: false, showEditAvatarDialog:false};

  }

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.childInfo !== this.props.childInfo) {
      if (this.props.childInfo !== undefined) {
        let passLocation: string = "";
        if (this.props.childInfo.passHistory && this.props.childInfo.passHistory.length > 0 && this.props.childInfo.passHistory[0].location) {
          passLocation = this.props.childInfo.passHistory[0].location;
        }
        this.setState({childInfo: this.props.childInfo, passLocation, changeMade: false});
      }
    }
  }

  public render() {
    const {classes} = this.props;
    const child = this.props.child;

    return (<>
      <div className={classes.card}>
        <div className={classes.cardTop} onClick={() => this.setState({showEditAvatarDialog:!this.state.showEditAvatarDialog})}>
          <ImgAvatar
            altText={child.firstName}
            color={child.color}
            imgName={child.avatar}
            imgUrl={child.imageAvatar?child.avatarURL:undefined}
            border={true}
            style={{
              width: 50,
              height: 50,
            }}
          />
          <div className={classes.topMiddle}>
            <span className={classes.name}>{child.firstName}</span>
          </div>
        </div>
        <div className={classes.list}>
          <div className={classes.row} style={{flexFlow: 'wrap'}}>
            <label htmlFor={"input-clothingSize"+child.id} className={classes.label}>
              {tn.lang.childInfoClothing}
              {this.state.childInfo.clothingSizeDate && this.state.childInfo.clothingSize && this.state.childInfo.clothingSize.length > 0
                ? (" (" + tn.formatDateMonthShort(new Date(this.state.childInfo.clothingSizeDate)) + ")")
                : ""}
            </label>
            <AutosizeTextArea
              id={"input-clothingSize"+child.id}
              value={this.state.childInfo.clothingSize}
              onChange={(event) => this.setState({
                childInfo: {
                  ...this.state.childInfo,
                  clothingSize: event.target.value, clothingSizeDate: Date.now()
                }, changeMade: true
              })}/>
          </div>
          <div className={classes.row} style={{flexFlow: 'wrap'}}>
            <label htmlFor={"input-childInfoShoeSize"+child.id} className={classes.label}>
              {tn.lang.childInfoShoeSize} {this.state.childInfo.shoeSizeDate
            && this.state.childInfo.shoeSize && this.state.childInfo.shoeSize.length > 0
              ? (" (" + tn.formatDateMonthShort(new Date(this.state.childInfo.shoeSizeDate)) + ")")
              : ""}
            </label>
            <AutosizeTextArea
              id={"input-childInfoShoeSize"+child.id}
              value={this.state.childInfo.shoeSize}
              onChange={(event) => this.setState({
                childInfo: {
                  ...this.state.childInfo, shoeSize: event.target.value,
                  shoeSizeDate: Date.now()
                }, changeMade: true
              })}/>
          </div>
        </div>

        <div className={classes.list}>
          <div className={classes.row} style={{flexFlow: 'wrap'}}>
            <label htmlFor={"input-childInfoInsurance"+child.id} className={classes.label}>{tn.lang.childInfoInsurance}</label>
            <AutosizeTextArea
              id={"input-childInfoInsurance"+child.id}
              value={this.state.childInfo.insurance}
              onChange={(event) => this.setState({
                childInfo: {...this.state.childInfo, insurance: event.target.value},
                changeMade: true
              })}/>
          </div>
          <div className={classes.row} style={{flexFlow: 'wrap'}}>
            <label htmlFor={"input-childInfoMeds"+child.id} className={classes.label}>{tn.lang.childInfoMeds}</label>
            <AutosizeTextArea
              id={"input-childInfoMeds"+child.id}
              value={this.state.childInfo.meds}
              onChange={(event) => this.setState({
                childInfo: {...this.state.childInfo, meds: event.target.value},
                changeMade: true
              })}/>
          </div>

          <div className={classes.list}>
            <div className={classes.row}>
              <div className={classes.label}>{tn.lang.childInfoVaccinations}</div>
              <Button className={classes.vaccineEditButton} color="primary"
                onClick={() => this.setState({showVaccDetails: true})}>
                {this.state.childInfo.vaccinations.length > 0 ? tn.lang.edit : tn.lang.add}
              </Button>
            </div>

            <div className={classes.vaccineGrid} onClick={() => this.setState({showVaccDetails: true})}>
              {this.state.childInfo.vaccinations.map((vaccination, index) =>
              <div  key={"vaccs" + index} className={classes.vaccineBox}>
                  <div className={classes.value} style={{marginBottom: '4px'}}>{vaccination.name}</div>
                  <div className={classes.label} style= {{fontSize: '11px', whiteSpace: 'nowrap'}}>
                    {tn.lang.childInfoVaccSubline(vaccination.lastDose, vaccination.doses)}
                  </div>
              </div>)}
            </div>

          </div>
        </div>

        <div className={classes.list}>
          <div className={classes.row}>
            <label htmlFor={"input-childInfoSocialNo"+child.id} className={classes.label}>{tn.lang.childInfoSocialNo}</label>
            <input
              id={"input-childInfoSocialNo"+child.id}
              type="text"
              value={this.state.childInfo.socialNo}
              onChange={(event) => this.setState({childInfo: {...this.state.childInfo, socialNo: event.target.value}, changeMade: true})}
              className={classes.value}
              placeholder={tn.lang.add}/>

          </div>
          <div className={classes.row}>
            <label htmlFor={"input-childInfoPassNo"+child.id} className={classes.label}>{tn.lang.childInfoPassNo}</label>
            <input
              id={"input-childInfoPassNo"+child.id}
              type="text"
              value={this.state.childInfo.passNo}
              onChange={(event) => this.setState({childInfo: {...this.state.childInfo, passNo: event.target.value}, changeMade: true})}
              className={classes.value}
              placeholder={tn.lang.add}/>
          </div>
          <div className={classes.row}>
            <label htmlFor={"input-childInfoPassLoc"+child.id} className={classes.label}>{tn.lang.childInfoPassLoc}</label>
            <div style={{display: 'flex'}}>
              <input
                id={"input-childInfoPassLoc"+child.id}
                type="text"
                value={this.state.passLocation}
                style={{width: '100%'}}
                onChange={(event) => this.setState({passLocation: event.target.value, changeMade: true})}
                className={classes.value}
                placeholder={tn.lang.add}/>
              <InfoIcon style={{fill: "rgb(132 132 132)"}} fontSize="small" onClick={() => this.setState({showPassDetails: true})}/>
            </div>
          </div>
          <div className={classes.row} style={{flexFlow: 'wrap'}}>
            <label htmlFor={"input-childInfoAllergies"+child.id} className={classes.label}>{tn.lang.childInfoAllergies}</label>
            <AutosizeTextArea
              id={"input-childInfoAllergies"+child.id}
              value={this.state.childInfo.allergies}
              onChange={(event) => this.setState({
                childInfo: {...this.state.childInfo, allergies: event.target.value},
                changeMade: true
              })}/>
          </div>
          <div className={this.state.changeMade ? classes.saveButton : classes.saveButtonHidden}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => this.saveChildInfo()}>{tn.lang.save}</Button>
          </div>
        </div>
      </div>
      <Dialog
        open={this.state.showPassDetails}
        title={tn.lang.childInfoPassHistory}
        content={
          <>
            {(this.props.childInfo !== undefined && this.props.childInfo.passHistory.length > 0)
              ? this.props.childInfo.passHistory.map((loc, index) => {
                const member = this.props.family.find((mem) => loc.changedBy === mem.id);
                return (<div key={index} className={classes.passBox}>
                  <div className={classes.passDate}><ImgAvatar
                    imgUrl={(member && member.imageAvatar)?member.avatarURL:undefined}
                    imgName={member ? member.avatar : 0}
                    style={{width: '16px', height: '16px', marginRight: '4px'}}
                    color={member ? member.color : "#cccccc"}/>
                    <div>{tn.formatDateShort(new Date(loc.time))}</div>
                  </div>
                  <div className={classes.passLocation}>{loc.location}</div>
                </div>);
              })
              : <div>{tn.lang.childInfoNoData}</div>}
          </>
        }
        actions={
          <Button size="small" color="primary" variant="contained" onClick={() => this.setState({showPassDetails: false})}>{tn.lang.okay}</Button>
        }
      />
      <ChildInfoVaccinations
        vaccinations={this.state.childInfo.vaccinations}
        showVaccDetails={this.state.showVaccDetails}
        hide={() => this.setState({showVaccDetails: false})}
        save={this.saveChildInfo}
      />
      {this.state.showEditAvatarDialog ?
        <UpdateFamilyMemberDialog
          familyMember={child}
          isOpen={this.state.showEditAvatarDialog}
          onClose={() => this.setState({showEditAvatarDialog:false})}
          onSubmit={this.handleUpdateFamilyMember}
          onSaveFile={(data) => this.props.updateFamilyMemberFileId(data)}
        /> : null
        }
    </>);
  }

  private saveChildInfo = (vaccinations = this.state.childInfo.vaccinations) => {
    const childInfo = {...this.state.childInfo, vaccinations};
    this.props.updateChildInfo({
      accountId: this.props.child.id,
      socialNo: childInfo.socialNo,
      passNo: childInfo.passNo,
      passHistory: this.state.passLocation,
      clothingSize: childInfo.clothingSize,
      shoeSize: childInfo.shoeSize,
      meds: childInfo.meds,
      allergies: childInfo.allergies,
      insurance: childInfo.insurance,
      vaccinations,
    });
    this.setState({childInfo, showVaccDetails: false, changeMade: false});
  };

  private handleUpdateFamilyMember = (value: IFamilyMember) => {
    this.props.updateFamilyMember(value);
    this.setState({showEditAvatarDialog:false});
  }
}

export default withStyles(childinfoStyle)(ChildInfo);



// WEBPACK FOOTER //
// ./src/components/childinfo/ChildInfo.tsx